import { render, staticRenderFns } from "./Navcon.vue?vue&type=template&id=2beef02f&scoped=true&"
import script from "./Navcon.vue?vue&type=script&lang=js&"
export * from "./Navcon.vue?vue&type=script&lang=js&"
import style0 from "./Navcon.vue?vue&type=style&index=0&id=2beef02f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beef02f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2beef02f')) {
      api.createRecord('2beef02f', component.options)
    } else {
      api.reload('2beef02f', component.options)
    }
    module.hot.accept("./Navcon.vue?vue&type=template&id=2beef02f&scoped=true&", function () {
      api.rerender('2beef02f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navcon.vue"
export default component.exports